import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ArrayHelper } from '@kildencore/helpers/array.helper';
import { LinksService } from '@kildencore/services/data/links.service';
import { InformationLinkInterface } from '@kildenshared/interfaces/information-link.interface';
import { Subject, takeUntil, tap, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'kilden3-infolinks',
  templateUrl: './infolinks.component.html',
  styleUrls: ['./infolinks.component.css'],
  imports: [MatMenuTrigger, MatIcon, MatMenu, MatMenuItem],
})
export class InfolinksComponent implements OnDestroy, OnInit {
  private readonly _linksService = inject(LinksService);

  sortedLinks: InformationLinkInterface[] = [];

  private readonly _onDestroy$ = new Subject<void>();

  ngOnDestroy(): void {
    this._onDestroy$.next();
    this._onDestroy$.complete();
  }

  ngOnInit(): void {
    this._linksService.informationLinks$
      .pipe(
        tap(links => {
          this.sortedLinks = links.sort(ArrayHelper.fieldSorter(['order_integer', 'tekst']));
        }),
        catchError((e: HttpErrorResponse) => {
          this.sortedLinks = [];
          return throwError(() => e);
        }),
        takeUntil(this._onDestroy$)
      )
      .subscribe();
  }
}
